import gql from "graphql-tag";

//Find products
export const FIND_PRODUCT = gql`
query findProducts($query: String, $filters: JSON) {
    findProducts(query: $query, filters: $filters) {
      products {
        name
        tourId
        duration
        hero
        startCity {
          name
        }
        endCity {
          name
        }
        pricesFrom{
          iso_currency_code
          amount
        }
      }
      filters {
        filter
        values {
          name
          order
        }
      }
    }
  }
`;


//Get all products 
export const GET_ALL_PRODUCTS = gql`
    query {
        allProducts{
            name
            tourId
            duration
            startCity {
                name
            }
            endCity {
                name
            }
        }
    }
`;

//Get single product
export const GET_PRODUCT = gql`
    query getProduct($id: String!, $currency:String) {
        getProduct(id: $id) {
            name
            duration
            mapImage:map
            inclusionList
            tourId
            startCity {
                name
            }
            endCity {
                name
            }
            hero
            pricesFrom {
              iso_currency_code
              amount
            }
            inclusionList
            videoId
            brochure
            brochureMini{
              title
              url
            }
            itinerary {
                day
                dayTitle
                body
                city {
                name
                }
                dayStops {
                name 
                }
            }
            options {
              name
              tour_id
              group_id
            }
            productCapacity(currency:$currency) {
                departure_date
                units:free_seats
                prices {
                amount
                iso_currency_code
                }
            }
        }
    }
`;


